// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1lwTK","dragIcon":"Choice_dragIcon__23bMg","left":"Choice_left__3w-6H","input":"Choice_input__1p6Gk"};